<script>
  import { startOfDay, endOfDay, subWeeks, getTime } from "date-fns";
  import getParams from "./../util/hash-params.ts";

  import AppSummary from "./../components/AppSummary.svelte";
  import AppCharts from "./../components/AppCharts.svelte";
  import AppStats from "./../components/AppStats.svelte";

  import ChartData from "./../util/app-charts.ts";

  import Loader from "./../components/Loader.svelte";
  import Navbar from "./../components/Navbar.svelte";
  import Footer from "./../components/Footer.svelte";
  import DateRange from "./../components/DateRange.svelte";

  export let store;

  let id = -1;
  let to = 0;
  let from = 0;

  function init() {
    const regex = /\/(\d*)(?:\/)?$/;
    id = parseInt(regex.exec(window.location.pathname)[1]);
    let params = getParams();
    let forceSnapshotLoad = false;
    if (!!params.to) {
      to = params.to;
    }
    if (!!params.from) from = params.from;
    if (!!params.to && !!params.from) {
      forceSnapshotLoad = true;
    }

    let initialized = !store.notInitialized;
    if (!to || !from) {
      to = Math.round(endOfDay(new Date()).getTime() / 1000) - 60;
      from =
        Math.round(subWeeks(startOfDay(new Date()), 2).getTime() / 1000) + 60;
    }
    let requests = [
      (initialized
        ? Promise.resolve()
        : store.loadAppInfo({ id }).then(() => {})
      ).then(() => afterAppLoad()),
      initialized && !forceSnapshotLoad
        ? Promise.resolve()
        : loadSnapshots(false)
    ];
    return Promise.all(requests)
      .then(() => store.commit("normalize"))
      .then(() => afterLoad());
  }

  function afterAppLoad() {
    app = store.state.app;
    const backUrl =
      "https://steamcdn-a.akamaihd.net/steam/apps/" +
      app.appId +
      "/page_bg_generated_v6b.jpg";
    document.body.style.backgroundImage = "url('" + backUrl + "')";
  }

  let pageLoader = init();
  let dataLoader = pageLoader;

  let app = {};
  let snapshots = [];
  let data;
  let statistics = [];

  let fromDate = new Date(from * 1000);
  let toDate = new Date(to * 1000);

  let lastUpdate = new Date();

  function loadSnapshots(normalize) {
    var result = store
      .loadSnapshots({
        id,
        from,
        to
      })
      .then(() => (snapshots = store.state.snapshots));
    if (normalize) {
      result = result.then(() => store.commit("normalize"));
    }
    return result.then(() => afterLoad());
  }

  function onRangeChange(event) {
    from = Math.round(startOfDay(event.detail.from).getTime() / 1000) + 60;
    to = Math.round(endOfDay(event.detail.to).getTime() / 1000) - 60;
    return loadSnapshots(true);
  }

  function afterLoad() {
    lastUpdate = new Date();
    data = new ChartData(store);
    window.location.hash = "#from=" + from + "&to=" + to;
  }

  $: {
    snapshots = store.state.snapshots;
    fromDate = new Date(from * 1000);
    toDate = new Date(to * 1000);
  }
</script>

<Navbar />
<main>
  {#await pageLoader}
    <Loader>Loading app...</Loader>
  {:then}
    <AppSummary {app} />
    <DateRange {fromDate} {toDate} on:change={onRangeChange} />
    {#if !!data}
      <AppStats {data} {lastUpdate} />
      <AppCharts {data} {lastUpdate} />
    {/if}
  {/await}
</main>
<Footer />
